import {useAuth0} from "../auth/SSO";
import {useNavBarContext} from "../navigation-bar/NavBar";
import Loading from "../common/Loading";
import React, {useState} from "react";
import {telemetryExport} from "../../api/TelemetryApi";
import moment from "moment";
import {makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import UseHubMetricsExport from "./hooks/UseHubMetricsExport";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        zIndex: -1,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center'
    }
}));

function formatDateTime(value) {
    const format = "MM-DD-YYYY HH:mm:ss";
    return moment(parseInt(value)).format(format);
}

export default function HubTelemetryExport({hubId, from, to}) {
    const classes = useStyles();

    const [done, setDone] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [error, setError] = useState(undefined);

    const {loading, user} = useAuth0();
    const {handleTitleUpdate} = useNavBarContext();

    if (loading || !user) {
        return <Loading/>;
    }

    const {hub, hubLoading} = UseHubMetricsExport({hubId});

    if (hubLoading || !hub) {
        handleTitleUpdate("Loading...");
        return <Loading/>;
    }

    const {title} = hub;

    handleTitleUpdate(title);

    if (error) {
        return (
            <div className={classes.root}>
                <Typography style={{color: "red"}}>{error}</Typography>
            </div>
        );
    }

    if (done) {
        return (
            <div className={classes.root}>
                <Typography>Done</Typography>
            </div>
        );
    }

    if (downloading) {
        return (
            <div className={classes.root}>
                <Grid container spacing={10} direction={"column"}>
                    <Grid item>
                        <Typography>Downloading...</Typography>
                    </Grid>
                    <Grid item>
                        <Loading/>
                    </Grid>
                </Grid>
            </div>
        );
    }

    telemetryExport(hubId, from, to)
        .then((response) => {
            return response.ok
                ? response.blob()
                : Promise.reject(response);
        })
        .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;

            const fromDate = formatDateTime(from);
            const toDate = formatDateTime(to);

            let filename = `${hub.title} [${fromDate} | ${toDate}].zip`;

            link.setAttribute('download', filename);

            document.body.appendChild(link);

            link.click();

            link.parentNode.removeChild(link);

            setDone(true);
        })
        .catch((error) => {
            error.json().then((json) => {
                setError(`${json.error.message} [${json.error.code}]`);
            });
        });

    setDownloading(true);

    return (
        <div className={classes.root}>Wait...</div>
    );
}